import React, { ReactNode } from "react";
import { IObservableValue, runInAction } from "mobx";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { fontWeights } from "et3-ui-library";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";

const NavGroup = withLiteObserverAndTheme<{
  title: string;
  icon: ReactNode;
  isOpenObservable: IObservableValue<boolean>;
  hasSelectedChild: boolean;
  children: ReactNode;
}>((props) => {
  const { title, icon, isOpenObservable, hasSelectedChild, children } = props;
  const isOpen = isOpenObservable.get();

  return (
    <React.Fragment>
      <ListItemButton
        onClick={() =>
          runInAction(() => isOpenObservable.set(!isOpenObservable.get()))
        }
        aria-expanded={isOpen}
        sx={
          hasSelectedChild
            ? {
                color: "primary.main",
                "& .MuiListItemIcon-root": { color: "inherit" },
                "& .MuiListItemText-primary": {
                  fontWeight: fontWeights.semibold
                }
              }
            : undefined
        }
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} />
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List disablePadding>{children}</List>
      </Collapse>
    </React.Fragment>
  );
});
export default NavGroup;
